<template>
    <div>
        <h3 class="mt-3">Booking Question</h3>

        <form novalidate @change="eventActivateUpdateFlag('BookingQuestion')">
            <div class="row mt-5">
                <div class="col-sm-10">

                    <label class="full">
                        <input type="text" v-model="getSelectedEvent.bookingQuestion" placeholder="e.g. Do you have the required fishing license?">
                        <div class="fs-smaller normal mt-2">Use this if you want to add a question to the booking process.</div>
                    </label>

                    <checkbox v-model="getSelectedEvent.bookingQuestionIsActive">
                        Is question active.
                    </checkbox>

                    <checkbox v-model="getSelectedEvent.bookingQuestionIsMandatory">
                        Is question mandatory.
                    </checkbox>

                </div>
            </div>
        </form>

    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    export default {
        props: {
            validations: {
                type: Object
            }
        },
        data: function() {
            return {
            }
        },
        created: function() {
        },
        computed: {
            ...mapGetters([
                'getSelectedEvent'
            ]),
        },
        methods: {
        },
        components: {
        }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// areaBookingQuestion.vue?62cd918c